/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

window.changeSelected = null;
var changeSelected = null;
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);

var formatter = new Intl.NumberFormat('es-CO', {
    style: 'currency',
    currency: 'COP',
    minimumFractionDigits: 0 
});
 window.mobileCheck = function() {
    let check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
}
function capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
function filterFaq(hash, classDom) {
    $(classDom).each(function(index) {
        var type = '#'+$(this).data('type');
        if(type == hash){
            $(this).show();
        }else{
            $(this).hide();
        }
    });
}
function loadMenuCollection() {
var catLvl1 = [];
var catLvl2 = [];
var catLvl3 = [];
objCollection.map((collec) => { 
    if(collec.hasOwnProperty('rules')){
        collec.rules.map((rules) => { 
            if(rules.column == "type" && collec.rules.length == 1){
                catLvl1.push(collec);
            }
            else if(rules.column == "type" && collec.rules.length == 2){
               catLvl2.push(collec);
            }
            else if(rules.column == "type" && collec.rules.length == 3){
                catLvl3.push(collec);
             } 
        });  
    }
 });
//  ORDENAR MEGA MENU SEGUN ORDER BLOCKS PERSONALIZADOR
var c = objMegaMenu.reduce(function (r, a, i) {
    r[a] = i;
    return r;
}, {});
catLvl1.sort(function (x, y) {
    return c[x.title] - c[y.title];
});
catLvl2.map((lvl2, idx2) => { 
    catLvl2[idx2].lvl3 = [];
    catLvl2[idx2].idx = idx2;
    catLvl2[idx2].index = idx2+1;
    catLvl3.map((lvl3, idx3) => { 
        if(lvl2.rules[1].condition.toLowerCase().normalize('NFD').replace(/([aeio])\u0301|(u)[\u0301\u0308]/gi,"$1$2").normalize() == lvl3.rules[1].condition.toLowerCase().normalize('NFD').replace(/([aeio])\u0301|(u)[\u0301\u0308]/gi,"$1$2").normalize()){
            lvl3.title = capitalize(lvl3.title);
            catLvl2[idx2].lvl3.push(lvl3);
            catLvl2[idx2].has_lvls = true;
        }
    }); 
}); 
catLvl1.map((lvl1, idx1) => {
    lvl1.title = capitalize(lvl1.title); 
    catLvl1[idx1].lvl2 = [];
    catLvl1[idx1].idx = idx1;
    catLvl1[idx1].index = idx1+1;
    catLvl2.map((lvl2, idx2) => { 
        if(lvl1.rules[0].condition.toLowerCase().normalize('NFD').replace(/([aeio])\u0301|(u)[\u0301\u0308]/gi,"$1$2").normalize() == lvl2.rules[0].condition.toLowerCase().normalize('NFD').replace(/([aeio])\u0301|(u)[\u0301\u0308]/gi,"$1$2").normalize()){
            lvl2.title = capitalize(lvl2.title);
            catLvl1[idx1].lvl2.push(lvl2);
            catLvl1[idx1].has_lvls = true;
        }
    });   
    if(mobileCheck() == true){
    // MENU MOBILE PRIMARY
    var templateMobile = Handlebars.compile($('#menu-primary-mobile').html()); 
    var htmlMobile = templateMobile(lvl1); 
    $('.js-mobile-menu__nav').append(htmlMobile);
    // MENU MOBILE COLLAPSIBLE
    var templateMobile2 = Handlebars.compile($('#menu-primary-mobile-collapsible').html()); 
    var htmlMobile2 = templateMobile2(lvl1); 
    $('.js-mobile-menu__inner').append(htmlMobile2);   
    }
    else{
       // MENU DESKTOP PRIMARY
    var templateDesktop = Handlebars.compile($('#menu-primary').html());
    var htmlDesktop = templateDesktop(lvl1);
    $('.js-nav-bar__linklist').append(htmlDesktop); 
    }
    

});
}
//loadMenuCollection();

/* newsletter */
$('body').on('click', '#input-checkbox-newsletter', function(e) {
    if ($('#input-checkbox-newsletter').is(":checked")){
        $('.footer__newsletter-wrapper button').addClass('button--primary');
        $('.footer__newsletter-wrapper button').removeClass('button--disabled');
        $('.footer__newsletter-wrapper button').removeAttr('disabled');
    }
    else{
        $('.footer__newsletter-wrapper button').removeClass('button--primary');
        $('.footer__newsletter-wrapper button').addClass('button--disabled');
        $('.footer__newsletter-wrapper button').Attr('disabled', true);
    }
});
/* FAQ */
$('body').on('click', '.card-faq-text-with-image a', function(e) {
    filterFaq($(this).attr('href'), ".faq__item");
});
/* PAGE NUESTRA GENTE */
$('body').on('click', '.js-photos-nuestra-gente img', function(e) {
    $('.js-popup-photos').html('<img src="'+$(this).attr('src').replace('_300x300','')+'"/>');
    $('.js-modal-nuestra-gente').attr('aria-hidden','false')
});
$('body').on('click', '.js-popup-nuestra-gente__close', function(e) {
    $('.js-modal-nuestra-gente').attr('aria-hidden','true');
});
/* PAGE ABOUT US */
$('body').on('click', '.page-about-us-sidebar-lists-item a', function(e) {
    filterFaq($(this).attr('href'), ".page-about-us-content-lists-item");
    $('.page-about-us-sidebar-lists-item a').each(function(index, item) {
        $(item).removeClass('active');
    });
    $(this).addClass('active');
});
$(document).ready(function() {
    if (typeof isPageFaq !== 'undefined' && isPageFaq) {
        if(window.location.hash) {
            filterFaq(window.location.hash,  ".faq__item");
          }
          else{
              $('.card-faq-text-with-image a[href="#metodos-de-pago"]').click();
          } 
    }
    if (typeof isPageAboutUs !== 'undefined' && isPageAboutUs) {
        if(window.location.hash) {
            filterFaq(window.location.hash, ".page-about-us-content-lists-item");
          }
          else{
              $('.page-about-us-sidebar-lists-item a[href="#¿quiénes-somos?"]').click();
          } 
    }
});
/* ancla */
$('body').on('click', '.js-ancla', function(e) {
    e.preventDefault();
    var codigo = "#" + $(this).data("ancla");
    $("html,body").animate({scrollTop: $(codigo).offset().top-200}, 1000);
});

/* MEGA MENU */
$('body').on('click', '.close_mega-menu', function(e) {
    $('.mega-menu').each(function(index, item) {
        $(this).attr('aria-hidden', true);
    });
});

/* ACORDEON PDP */
$('body').on('click', '.product-block-list__item .card__collapsible-button', function(e) {
    setTimeout(function(){ 
        $('.accordion-open').attr('aria-expanded', true);
        $('.accordion-close').attr('aria-expanded', false);
    }, 200);    
});
/* MIS DIRECCIONES ACCOUNT */
$('.selector-address-province').on('change',(event) => {
    $('.selector-address-city').html('<option disabled="disabled" value="---" data-provinces="[]">---</option>');
   // alert(event.target.value);
    $(allCities).map((node, item) => { 
        if(event.target.value.toLowerCase() == item.Departamento.toLowerCase()){
            item.Municipio.map((city) => { 
                $('.selector-address-city').append('<option value="'+city+'" data-provinces="[]">'+city+'</option>')
               // console.log(city); 
            });
        }

    });
});
$('.selector-address-province-edit').on('change',(event) => {
   // 
   var idSelectProvince = event.target.attributes.id.value;
   var idSelectCity = idSelectProvince.replace('[province]', '-city');
   var idSelectCityEdit = idSelectCity+'--select';
   $('#'+idSelectCityEdit).html('<option disabled="disabled" value="---" data-provinces="[]">---</option>');
    allCities.map((item) => { 
        item.Municipio.sort(function (a, b) {
            if (a > b) { return 1; }
            if (b > a) { return -1; }
          return 0;
          });
        if(event.target.value.toLowerCase() == item.Departamento.toLowerCase()){
            item.Municipio.map((city) => { 
                $('#'+idSelectCityEdit).append('<option value="'+city+'" data-provinces="[]">'+city+'</option>')
              //  console.log(city); 
            });
        }
    });/* */
});
$('.selector-address-city').on('change',(event) => {
    $('.input-address-city--hidden').val(event.target.value);
   // alert( event.target.value );
});
$('.selector-address-city-edit').on('change',(event) => {
    $('.input-address-city-edit--hidden').val(event.target.value);
   // alert( event.target.value );
});
setTimeout(function(){ 
    $('#address-new[company]').each(function(index, item) {
    //console.log(item);
    });
    $('.address-list__item').each(function(index, item) {
        var idAddress = $(this).find('.address-list--edit').attr('aria-controls');
        var dataCityAddress = $(this).data('city-address');
        //console.log(dataCityAddress);
        $('#'+idAddress).find('.selector-address-province-edit option').each(function() {
            if($(this).val() == dataCityAddress){
                $(this).attr('selected','selected');
            }
        });
        var currentCity = $('#'+idAddress).find('.selector-address-province-edit').val();
    
       // console.log(currentCity);
       $('#'+idAddress).find('.selector-address-city-edit').html('<option disabled="disabled" value="---" data-provinces="[]">---</option>');
        allCities.map((item) => { 
            item.Municipio.sort(function (a, b) {
                if (a > b) { return 1; }
                if (b > a) { return -1; }
              return 0;
              });
            if(currentCity.toLowerCase() == item.Departamento.toLowerCase()){
               // console.log(currentCity.toLowerCase());
               // console.log(item.Municipio); 
              item.Municipio.map((city) => { 
                    if($('#'+idAddress).find('.input-address-city-edit--hidden').val().toLowerCase() == city.toLowerCase()){
                        $('#'+idAddress).find('.selector-address-city-edit').append('<option value="'+city+'" data-provinces="[]" selected>'+city+'</option>')
                        //console.log(city); 
                    }
                    else{
                       
                        $('#'+idAddress).find('.selector-address-city-edit').append('<option value="'+city+'" data-provinces="[]">'+city+'</option>')
                    }
              }); 
            }
        });
    });
    $('.selector-address-province').change();
    updateUrlMiniCart();
    
    }, 2000);
/* FILTRO COLOR */
function getEqualColor() {
    //console.log(colorsHex);
    colorsHex.map((item) => { 
        var arrayItem = Object.values(item);
        //console.log(arrayItem[0].toLowerCase());
        $('.color-swatch .color-swatch__item').each(function(index, item) {
            var value = $(this).attr('style');
            currentItem = arrayItem[0].toLowerCase().replaceAll(' ','');
            if(value.indexOf(currentItem) != -1 ){
               var valueHex = $(this).attr('style').replace(currentItem, arrayItem[1]);
               console.log(valueHex);
               $(this).attr('style',valueHex);
            }
        });
        
    });
    
}
getEqualColor();

/* ESCALA DE PRECIOS */
$('body').on('click', '.js-view', function(e) {
    e.preventDefault();
    $('.js-view').hide();
    getDiscountProduct(1);
});
$('body').on('click', '.quantity-selector__button', function(e) {
    setDiscountProduct(CartQuantity)
});
const formatterPeso = new Intl.NumberFormat('es-CO', {
    style: 'currency',
    currency: 'COP',
    minimumFractionDigits: 0
});
function getDiscountsProducts(discount_product, id) {
    if (discount_product !== null) {
        discount_product.typologies.map((item) => {
            if(item.customer_type == list_price){
                console.log('discount_product', item);
            $('#tag-text-pdp').html('<li class="mini-cart__discount">Compre '+item.ranges[0].quantity+' unidades y obtenga un '+item.ranges[0].percentage+'% de descuento en su pedido.</li>')
            }
        });
    } 
}
function getDiscountProduct(view) {
    let list_price = "SIN_LISTA";
    if(product_multip == false){
        list_price = list_prices_selected;
    }
    else{
        list_price = current_list;
    }
    function htmlTableDiscount(item){
      console.log("Crea tabla de descuentos")
        console.log('item', item)
        $('#table-discount').html('');
        discount_current = {"Descuento": "0"};
        objDiscount = item;
        var table = document.createElement("table"), row, cellA, cellB;
        document.getElementById("table-discount").appendChild(table);
        row = table.insertRow();
        row.insertCell(0).outerHTML = "<th>"+text_discount_table_cell_1+"</th>";
        row.insertCell(1).outerHTML = "<th>"+text_discount_table_cell_2+"</th>";
        let iterations = parseInt(item.ranges.length);
        if(item.ranges.length > 2){
            $('.view-more-discount').show();
        }
        function setTableDiscount(data){
          
            row = table.insertRow();
            cellA = row.insertCell(); 
            cellB = row.insertCell();
            cellA.innerHTML = data.quantity+"+";
            cellA.classList.add("discount-table-cell-quantity");
            let price_with_discount = parseInt(current_price-(current_price*data.percentage/100));
            
            data["price"] = price_with_discount;
            console.log(price_with_discount);
            price_with_discount = formatterPeso.format(price_with_discount);
            price_with_discount = price_with_discount.split(",");
            cellB.innerHTML = price_with_discount[0];
          
            if (data.quantity < 1) {
              $('#table-discount tbody tr:nth-child(2)').hide();
            }
          
            
           // data.push({"price":price_with_discount});
            
           //  cellB.innerHTML = data.percentage+'% <span class="discount-table-cell-percentage">Compra '+data.quantity+' unidades y obten un '+data.percentage+'%</span>';
            if (!--iterations) {
               // console.log(item.ranges[range]);
            }
        }
  console.log('discount_product', discount_product);
        if(view == 0){
           // console.log(item.ranges.length)
            if(item.ranges.length  > 1){
                for (let range = 0; range < 2; range++) {
                    let data = item.ranges[range];
                  //  price_discount_product.push(data);
                //  console.log(data)
                    setTableDiscount(data);
                }
            }
            else{
                let data = item.ranges[0];
                setTableDiscount(data);
            }
        }
        else{
            for (let range in item.ranges) {
              
                let data = item.ranges[range];
                setTableDiscount(data);
            }
        }

    }
    let check_sin_lista = false;
    if (discount_product !== null) {
    discount_product.typologies.map((item) => {
        if(item.customer_type == list_price){
            console.log(item);
            htmlTableDiscount(item);
            $('.tag__discount-pdp').show();
            check_sin_lista = true;
        }
        if(item.customer_type == "SIN_LISTA" && check_sin_lista == false){
            console.log(check_sin_lista)
            htmlTableDiscount(item);
            $('.tag__discount-pdp').show(); 
           }
    });
    }
    $('.js-producto-info-inventory').show();
}
function setDiscountProductPrice(CartQuantity) {
    let arrayDiscount = [];
    for (let range in objDiscount.ranges) {
        let data = objDiscount.ranges[range];
        if(data.quantity <= CartQuantity){
            arrayDiscount.push(data.percentage);
        }
}
}
function setDiscountProduct(CartQuantity) {
    $(".js-view").click();
    let arrayDiscount = [];
    let arrayPriceDiscount = [];
    let currentQuantity = $('#quantity').val();
    let missing_quantity = 0;
    let cancelcount = 0;
    arrayDiscount.push(0);
    arrayPriceDiscount.push(current_price);
    let count = 0;
    var stocknumber = parseInt($('.current_inventory_qty').text());

      console.log("Diego es gay")
      console.log(arrayDiscount)
      console.log(arrayPriceDiscount)

    var resta = currentQuantity-stocknumber;
  console.log("stocknumber ", stocknumber);
  console.log("currentQuantity ", currentQuantity);
    if(currentQuantity > stocknumber) {
      console.log("entrando para validacion ");
      $('#moreinventory').show();
      if(resta == 1) {
        $('#moreinventory').html('Tenemos '+ stocknumber +' en el inventario el otro restante será entregado en el transcurso de estos días.');
      } else {
        $('#moreinventory').html('Tenemos '+ stocknumber +' en el inventario los otros '+ resta + ' serán entregado en el transcurso de estos días.');
      }          
    } else { $('#moreinventory').hide(); }

  
    for (let range in objDiscount.ranges) {
        count = parseInt(range);
        count = count+1;
        let data = objDiscount.ranges[range];
        arrayDiscount.push(data.percentage);
        arrayPriceDiscount.push(data.price);
        console.log("data.price ", data.price);
        console.log("data.quantity ", data.quantity);
        console.log("currentQuantity ", currentQuantity);
        if(data.quantity <= currentQuantity){
            console.log(arrayDiscount);
            
          discount_current = {"Descuento": arrayDiscount[count]};
          $('.js-producto-info-select-price .money').text(formatter.format(parseInt(arrayPriceDiscount[count])));
          if (cancelcount < 1) {
            missing_quantity = objDiscount.ranges[0].quantity-currentQuantity;
          }
          
          if(missing_quantity > 0){
              $('.cart-quantity-plus').attr('data-tooltip','Faltan '+missing_quantity+' unidades para un mayor descuento');
              console.log(objDiscount.ranges.length);
              console.log(count);
          } else {
              cancelcount = cancelcount+1;
              $('.cart-quantity-plus').attr('data-tooltip','Máximo descuento obtenido');  
          }
        }  
}
let oneRange = objDiscount.ranges[0];
if(oneRange.quantity > currentQuantity){
    console.log(oneRange, arrayPriceDiscount[0]);
    discount_current = {"Descuento": arrayDiscount[0]};
    let missing_quantity = oneRange.quantity-currentQuantity;
    $('.cart-quantity-plus').attr('data-tooltip','Faltan '+missing_quantity+' unidades para un descuento');
    $('.js-producto-info-select-price .money').text(formatter.format(parseInt(arrayPriceDiscount[0])));
    
}    

}

function cerrarAdvertencia() {
  $('.wairning-box').hide();
  $('.info-box-product').show();
}

/* LISTA DE PRECIOS PDP */
$('body').on('change', '#lista-de-precios .product-form__single-selector', function(e) {
    $(productObject.variants).map((node, item) => { 
     if(item.title == list_prices_selected){   
      //   console.log(item);
     let formatPrice = item.price.toString();
     console.log(formatPrice);
     if(formatPrice == 0){
         $('.product-form__info-content .money').text('$ '+formatPrice); 
     }
     else{
         formatPrice = formatPrice.substring(0,formatPrice.length-2);
         current_price = formatPrice;
         console.log(current_price)
         $('.product-form__info-content .money').text(formatter.format(parseInt(formatPrice)));
         if (typeof productObject !== 'undefined') {
            getDiscountProduct(0);
        }
     }
     }
    });
 });

 $('.cart-quantity').on('input', function() {
     var cartQuantity = $(this).val();
     /*if(availableItemInventory < cartQuantity && isContinue == false){
        // $(this).val(productTotalQt);
         document.querySelector(".quantity-selector__value").value=availableItemInventory;
     }*/
     setDiscountProduct(CartQuantity);
     console.log(cartQuantity);
     console.log(availableItemInventory);
     
 });
 /* PRODUCT MULTIPLE PDP */
function getProductMultip() {
   
    //$('.js-product-form__payment').hide();
    //$('.js-producto-info-select-quantity').hide();
    if(product_multip == true ){
        
        var hasVariantProdMult = false;
        var arrayVariantProdMult = [];
        
        fetch('/search?type=product&q=variants.sku:'+productObject.variants[0].sku+'&view=sku', {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
          })
          .then((res) => res.json())
          .then((data) => {          
            var currentVariant = {};
            data.products.map((item) => {
                if(/*item.id != productObject.id && */item.variants[0].sku == productObject.variants[0].sku){
                    item.variants.map((variant) => {
                       // console.log(variant.title);
                      //  console.log(current_list);
                        if(variant.title == current_list){
                            
                        console.log(variant.sku,variant.title );
                        hasVariantProdMult = true;
                        //arrayVariantProdMult = item.variants;
                        variantId = variant.id;
                        currentVariant = variant;
                        updateVariant(variant);
                        htmlSelectMultip(item.variants);
                        if (typeof productObject !== 'undefined') {
                            getDiscountProduct(0);
                        }
                      //  break;
                        }
                        else{
                            
                            var currentLocation = locationTag.replace('-','');
                            if(variant.title.indexOf('MSIN_LISTA'+currentLocation) != -1 && hasVariantProdMult == false){
                                console.log(item);
                                console.log(variant.title);
                                hasVariantProdMult = true;
                                variantId = variant.id;
                                currentVariant = variant;
                                updateVariant(variant);
                                htmlSelectMultip(item.variants);
                                if (typeof productObject !== 'undefined') {
                                    getDiscountProduct(0);
                                }
                            }
                        }
                    });
                    
                }
                
            });
            function updateVariant(variant) {
                let formatPrice = variant.price.toString();
                if(formatPrice == 0){
                    $('.product-form__info-content .money').text('$ '+formatPrice); 
                }
                else{
                    formatPrice = formatPrice.substring(0,formatPrice.length-2);
                    $('.product-form__info-content .money').text(formatter.format(parseInt(formatPrice)));
                }
                 variantContinue = variant.available;
              
                    loadInventaryProduct(variant.id);
               
            }
            $('.js-producto-info-select-price').show();
            $('.js-producto-info-select-quantity').show();
        });
        //console.log(hasVariantProdMult);
    }
    else{
       
       // console.log('hlaaaa')
       
            loadInventaryProduct(variantId);
        
        $('#lista-de-precios option').map((node, item) => {
            $(item).removeAttr("selected");
            if(item.text == list_prices_selected){
                changeSelected = document.querySelectorAll('#lista-de-precios .product-form__single-selector')[0];
                $("#lista-de-precios .product-form__single-selector").change();
            }
            });
            $('.no-js option').map((node, item) => { 
            var variantText = item.text.split(" - ").shift();     
          //  console.log(node, item);
            $('.no-js option:eq('+node+')').removeAttr("selected");
            if(variantText == list_prices_selected){
                //console.log(list_prices_selected);
                $('.no-js option:eq('+node+')').attr("selected", true);
                //console.log($('.no-js select').find('option:selected').val());
                }
                else{
                $('.no-js option:eq('+node+')').removeAttr("selected");
                }
            });
        $('.js-producto-info-select-price').show();
        console.log('precio mult 1');
        loadInventaryProduct(variantId);
        
    }
}
function htmlSelectMultip(array) {
        var htmlOption = '';
        
        array.map((variant) => {
            //console.log(variant.price);
            let formatPrice = variant.price.toString();
            formatPrice = formatPrice.substring(0,formatPrice.length-2);
            if(current_list == variant.title){
                htmlOption += '<option selected="selected" value="'+variant.id+'" data-sku="'+variant.sku+'">'+variant.title+' - '+formatter.format(parseInt(formatPrice))+'</option>';
            }
            else{
                var currentLocation = locationTag.replace('-','');
                if(variant.title.indexOf('MSIN_LISTA'+currentLocation) != -1 ){
                    htmlOption += '<option selected="selected" value="'+variant.id+'" data-sku="'+variant.sku+'">'+variant.title+' - '+formatter.format(parseInt(formatPrice))+'</option>';
                }else{
                    htmlOption += '<option value="'+variant.id+'" data-sku="'+variant.sku+'">'+variant.title+' - '+formatter.format(parseInt(formatPrice))+'</option>';
                }
                 }
            });
        
        var divSelect = '<select id="product-select-'+variantId+'" name="id">'+htmlOption+'</select>';
        //console.log(divSelect);
        //console.log('hola');
        $('.no-js .select-wrapper').html(divSelect);
}
function updateUrlCart() {
    const regex_Num = /([_]+[1-9])/g;
    $('.js-page-cart-line-items .line-item').each(function(index, item) {
        var domUrl = $(this).find('.line-item__title').attr('href');
        if(domUrl.search(regex_Num) != -1){  
            domUrl = domUrl.replace(regex_Num, '');
            document.querySelectorAll('.js-page-cart-line-items .line-item')[index].getElementsByTagName("a")[1].setAttribute("href", domUrl); 
           // console.log($(this).find('.line-item__title'));
        }
    });
}
function updateUrlMiniCart() {
    const regex_Num = /([_]+[1-9])/g;
    $('.mini-cart__line-item').each(function(index, item) {
        var domUrl = $(this).find('.mini-cart__product-title').attr('href');
        //console.log(domUrl);
        if(domUrl.search(regex_Num) != -1){
            
            domUrl = domUrl.replace(regex_Num, '');
            //console.log(index);
           // $(this).find('.mini-cart__product-title').attr('href', domUrl);
            document.querySelectorAll('.mini-cart__line-item')[index].getElementsByTagName("a")[1].setAttribute("href", domUrl); 
            //console.log($(this).find('.mini-cart__product-title'));
        }
    });
    //
}

 if ($(".quantity-selector__value").length) {
     document.querySelector(".quantity-selector__value").addEventListener ("keyup", (evt) => {
       if (evt.key === "Enter" && isContinue == false) {
           console.log(availableItemInventory);
           console.log(evt);
           //$('.quantity-selector__value').val(availableItemInventory);
           document.getElementById('id1').value=availableItemInventory ;
       }
   });
   }
/* PDP GENERAL */
$(document).ready(function() {
    if (typeof isPageProduct !== 'undefined' && isPageProduct) {
        $('.accordion').accordion({
            defaultOpen: 'section1',
            cookieName: 'accordion_nav'
        });
      // var productFichaTecnica = $('.rte table').parent().html();
      var productFichaTecnica = $('.product-attached-documents').html();
       $('#cont-product-attached').html(productFichaTecnica);
       $('.product-attached-documents').html('');
       var productFichaTecnica = $('.table-wrapper').html();
        $('#cont-product-ficha-tecnica').html(productFichaTecnica);
        $('.table-wrapper').html('');
        $('.product-description-short table').html('');
        var currentDescription = $('.product-description-short').html().replace(/<[^>]*>?/gm, '').substring(0,180);;
        $('.product-description-short .text-description-product').html(currentDescription+'<span>... <a href="#" class="js-ancla" data-ancla="product-block-description">Leer más</a></span>');
        getProductMultip();
    }
    if (typeof isPageCart !== 'undefined' && isPageCart) {
        updateUrlCart();
    }
    if(mobileCheck() == true){
        $(".product-item--horizontal").each(function(index) {
            $(this).addClass('product-item--vertical');
            $(this).removeClass('product-item--horizontal');
        });
    }
    
});
/* INVENTARIO DE PRODUCTO POR BODEGA */
function loadInventaryProduct(variantId) {
    for (let i = 0; i < arrayLocations.length; i++){
      
        if (arrayLocations[i].location_tag == locationTag) {
          var locationId = arrayLocations[i].location_id
         fetch('https://get-inventary-location-texco.herokuapp.com/inventaryProduct', {
         method: 'POST',
         headers: { 'Content-Type': 'application/json' },
         body: JSON.stringify({
           "location_id": locationId,
           "variant_id": variantId
         }),
       })
       .then((res) => res.json())
       .then((data) => {

         console.log("Esto es data ", data)
         
             if(data.hasOwnProperty("available") == true){
           availableItemInventory = data.available;
           var inputQuantity = document.getElementById("quantity");
           $('.current_inventory_qty').text(availableItemInventory);
           if(availableItemInventory > 0){
             if(variantContinue != true){
              inputQuantity.setAttribute("max",availableItemInventory); // set a new value;
            } else {
               inputQuantity.setAttribute("max",9999); // set a new value;
            }
             
             $('.product-form__inventory').text(availableItemInventory+' Unidades disponibles');
             $('.js-producto-info-inventory').show();
             $('.js-producto-info-select-quantity').show();
             $('.js-product-form__payment').show();
             $('.product-form__payment-container').html('<button type="submit" class="product-form__add-button button button--primary" data-action="add-to-cart">Añadir al carrito</button>');
           }else{
             
             $('.product-form__inventory').text('Tenemos '+availableItemInventory+' unidades disponibles en tu ubicación.');
             $('.js-producto-info-inventory').show();
             $('.js-product-form__payment').show();
             if(variantContinue != true){
                $('.product-form__payment-container').html('<button type="submit" class="product-form__add-button button button--disabled" disabled="">Agotado</button>');
              } else {
               $('.product-form__payment-container').html('<button type="submit" class="product-form__add-button button button--primary" data-action="add-to-cart">Añadir al carrito</button>');
                 
              }
           } 
           $('.product-form__info-content .money').attr('data-product-id',variantId); 
         }
         else{
            $('.product-form__payment-container').html('<button type="submit" class="product-form__add-button button button--disabled" disabled="">Agotado</button>');
            $('.js-product-form__payment').show();
            $('.js-producto-info-select-quantity').hide();
         }
       })
       .catch((err) => console.log(err));   
         break;
       }
      }   
    const reloadUsingLocationHash = () => {
        window.location.hash = "reload";
      }
      window.onload = reloadUsingLocationHash();
}